import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getKyc, GetKycParams} from '../api';
import {QUERY__KYC} from '../queryKeys';
import {KycRecord} from '../types';

export const useGetKyc = <SelectedData = GetListOutput<KycRecord>>(
  params?: GetKycParams,
  options?: QueryOptionsForList<KycRecord, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__KYC, params],
    queryFn: () => getKyc(params),
    ...options,
  });
};
